export default __webpack_public_path__ + "static/media/vitalik_poap_12.c37028f8.svg";